import React from "react";
import { Delete } from "lucide-react";

/**
 * Tastierino numerico touch-friendly per POS.
 * onChange riceve la stringa aggiornata. Supporta max 2 decimali.
 * mode: 'currency' | 'integer' | 'pin'
 */
export default function NumericKeypad({ value, onChange, mode = "currency" }) {
  const push = (c) => {
    const v = String(value || "");
    if (c === ".") {
      if (mode !== "currency") return;
      if (v.includes(".")) return;
      onChange(v === "" ? "0." : v + ".");
      return;
    }
    // limite 2 decimali per currency
    if (mode === "currency" && v.includes(".")) {
      const dec = v.split(".")[1] || "";
      if (dec.length >= 2) return;
    }
    // per pin: max 8 cifre
    if (mode === "pin" && v.length >= 8) return;
    onChange((v + c).replace(/^0(?=\d)/, ""));
  };
  const back = () => onChange(String(value || "").slice(0, -1));
  const clear = () => onChange("");

  const keys = [
    ["7", "8", "9"],
    ["4", "5", "6"],
    ["1", "2", "3"],
    [mode === "currency" ? "." : "clear", "0", "back"],
  ];

  return (
    <div className="grid grid-cols-3 gap-2 select-none" data-testid="numeric-keypad">
      {keys.flat().map((k) => {
        if (k === "back")
          return (
            <button
              key="back"
              data-testid="keypad-back"
              onClick={back}
              className="h-16 rounded-md bg-velta-bg border border-velta-border hover:border-velta-ink font-medium flex items-center justify-center btn-tactile active:scale-95"
            >
              <Delete className="w-6 h-6" />
            </button>
          );
        if (k === "clear")
          return (
            <button
              key="clear"
              data-testid="keypad-clear"
              onClick={clear}
              className="h-16 rounded-md bg-velta-bg border border-velta-border hover:border-velta-error hover:text-velta-error font-mono font-medium text-lg btn-tactile"
            >
              C
            </button>
          );
        return (
          <button
            key={k}
            data-testid={`keypad-${k}`}
            onClick={() => push(k)}
            className="h-16 rounded-md bg-white border border-velta-border hover:border-velta-ink font-mono font-bold text-2xl btn-tactile active:scale-95"
          >
            {k}
          </button>
        );
      })}
    </div>
  );
}
